/* global */
(function () {
    'use strict';

    var DOM = {
            DESC: '.desc_to_show',
            SHOW_DESC: '.show_desc'
        },
        $showDesc = document.querySelector(DOM.SHOW_DESC);

    if ($showDesc) {
        attachEvents();
    }

    /**
     * Initialize show more event
     */
    function attachEvents() {
        $showDesc.addEventListener('click', onShowMoreMobileDesc);
    }

    /**
     * Show entire overview description
     */
    function onShowMoreMobileDesc() {
        this.style.display = 'none';
        document.querySelectorAll(DOM.DESC).forEach(removeEllipsis);
    }

    /**
     * Remove ellipsis in descriptions
     * @param {Object} element
     */
    function removeEllipsis(element) {
        element.classList.add('no-multiline-ellipsis');
    }

}());
